import { Pipe, PipeTransform } from '@angular/core';
import { Inject } from '@angular/core';
import { NgModule } from '@angular/core';

@Pipe({ name: 'moduleName' })
export class ModuleNamePipe implements PipeTransform {
    transform(moduleId: any[], modules: any[]) {
        if (modules && modules.length && typeof moduleId[0] === "string") {
            return modules.filter((data) => {
                return moduleId.indexOf(data.Id) >= 0;
            })
        }

        return moduleId;
    }
}

@Pipe({ name: 'nameById' })
export class NameByIdPipe implements PipeTransform {
    /**
     * @param id - guid for selected item
     * @param itemList - list of all items
     * @param field - value field to return from the item list
     * @param check - field in the item list to compare against
     */
    transform(id: any, itemList: any[], field: string, check: string) {
        let response = "";
        try {
            if (id && itemList && field && check) {
                let dataItem = itemList.find((item) => {
                    return (item[check] === id);
                });
                return dataItem[field];
            }

            if (itemList && itemList.length && itemList[0].Name) {
                if (id && id.length) {
                    let items = itemList.filter((data) => {
                        return id.indexOf(data.Id) >= 0;
                    })
                    for (var i in items) {
                        let punc = items.indexOf(items[i]) < items.length - 1 ? ", " : "";
                        if (items[i]) response += items[i].Name + punc;
                    }
                } else if (itemList[0].ModuleId) {
                    let list = itemList.find((item) => {
                        return (item.ModuleId === id);
                    });
                    if (list) response = list.Name;
                }

                else {
                    let dataItem = itemList.find((item) => {
                        return (item.Id === id);
                    });
                    response = dataItem ? dataItem.Name : "";
                }
            }
        } catch (e) {
            // console.error(e);
            response = "";
        }

        return response;
    }
}


@Pipe({ name: 'fullName' })
export class FullNamePipe implements PipeTransform {
    transform(data: any): string {
        let fn: string;
        if (data && (data.FirstName)) {
            fn = data.FirstName;
            if (data.LastName) fn = fn + ' ' + data.LastName;
        }
        return fn;
    }
}
